import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { Game, GamesInCategories } from '../models/game.model';
import { GamesListCategory, GamesListLangFilter } from '../types/game.type';

@Injectable({
  providedIn: 'root'
})
export class GameService {
  private apiUrl = `${environment.apiUrl}/games`;

  constructor(private http: HttpClient) { }

  getGames(lang: string = 'en', status: string = 'published', order: string = 'DESC', limit: number = 32, searchBy: string = '', searchValue: string = ''): Observable<{ games: Game[], pagination: any }> {
    const params: any = { lang, status, order, limit };
    if (searchBy && searchValue) {
      params['searchBy'] = searchBy;
      params['searchValue'] = searchValue;
    }
    return this.http.get<{ games: Game[], pagination: any }>(this.apiUrl, { params });
  }

  getGamesInCategory(category: GamesListCategory, lang: string = 'en', langFilter: GamesListLangFilter, hidePlayed: boolean = false): Observable<GamesInCategories> {
    const params: any = { lang, langFilter, hidePlayed };
    return this.http.get<GamesInCategories>(`${this.apiUrl}/category/${category}`, { params });
  }

  getGameBySlug(slug: string, lang: string = 'en'): Observable<Game> {
    return this.http.get<Game>(`${this.apiUrl}/slug/${slug}?lang=${lang}`);
  }

  getGameSlugInfo(id: number): Observable<{ slug: string, title: string, lang: string  }> {
    return this.http.get<{ slug: string, title: string, lang: string  }>(`${this.apiUrl}/slug-info/${id}`);
  }
}
